module.exports = __webpack_public_path__ + "static/img/30004 (3).72a7644.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30004 (3).jpg
// module id = BSWT
// module chunks = 14